import { render, staticRenderFns } from "./EditMaterial.vue?vue&type=template&id=860aaa04&scoped=true&"
import script from "./EditMaterial.vue?vue&type=script&lang=js&"
export * from "./EditMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860aaa04",
  null
  
)

export default component.exports